<template>
  <!--
  ==========================================================================
  General
  ==========================================================================
  -->
  <form class="h-100 scrollable padded">
    <string-form-field
      :label="$t('creditAssignmentRequest.fields.title')"
      required
      :value="value.title"
      :disabled="disabled"
      :error="findError('title')"
      @input="propertyChange('title', $event)"
    />

    <number-form-field
      :label="$t('creditAssignmentRequest.fields.amount')"
      required
      prepend="€"
      :precision="2"
      :value="value.amount"
      :disabled="disabled"
      :error="findError('amount')"
      @input="propertyChange('amount', $event)"
    />

    <string-form-field
      :label="$t('creditAssignmentRequest.fields.description')"
      multiline
      :value="value.description"
      :disabled="disabled"
      :error="findError('description')"
      @input="propertyChange('description', $event)"
    />
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
import ErrorCounterMixin from "vue-forms/mixins/ErrorCounterMixin";

export default {
  mixins: [EditorMixin, ErrorCounterMixin]
};
</script>
